<script setup>
import { computed } from 'vue';

const props = defineProps({
  channel: { type: String, required: true },
});

// Cor por canal usa o design system do fork (n-*), não hex solto.
const TONE = {
  whatsapp: 'bg-n-teal-3 text-n-teal-11',
  instagram: 'bg-n-ruby-3 text-n-ruby-11',
  facebook: 'bg-n-blue-3 text-n-blue-11',
  email: 'bg-n-amber-3 text-n-amber-11',
  webchat: 'bg-n-blue-3 text-n-blue-11',
  sms: 'bg-n-amber-3 text-n-amber-11',
  telegram: 'bg-n-blue-3 text-n-blue-11',
  line: 'bg-n-teal-3 text-n-teal-11',
  api: 'bg-n-alpha-2 text-n-slate-11',
  other: 'bg-n-alpha-2 text-n-slate-11',
  all: 'bg-n-alpha-2 text-n-slate-11',
  unknown: 'bg-n-ruby-3 text-n-ruby-11',
};

const toneClass = computed(() => TONE[props.channel] ?? TONE.other);
</script>

<template>
  <span
    class="inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap"
    :class="toneClass"
  >
    {{ $t(`FLOW_AUTOMATIONS.INDEX.CHANNEL.${channel}`) }}
  </span>
</template>
